const products = [
    {
        "id": "asher-metallic",
        "name": "Metallic",
        "price": "€45",
        "image": "/collection/asher_metallic.png",
        "type": "T-Shirt",
        "description": "A silver metallic ROTB graphic on a black tee.",
        "newCollection": true,
        "variants": [
            {
                "name": "Freestyler",
                "price": "€45"
            },
            {
                "name": "Asher",
                "price": "€48"
            }
        ]
    },
    {
        "id": "asher-girl",
        "name": "Girl Grey",
        "price": "€45",
        "image": "/collection/girl_grey_no_pill_asher.png",
        "type": "T-Shirt",
        "description": "A monochrome portrait with the bracketed ROTB signature.",
        "newCollection": true,
        "variants": [
            {
                "name": "Freestyler",
                "price": "€45"
            },
            {
                "name": "Asher",
                "price": "€48"
            }
        ]
    },
    {
        "id": "asher-vertical",
        "name": "Vertical",
        "price": "€45",
        "image": "/collection/rotb_vertical_asher.png",
        "type": "T-Shirt",
        "description": "The purple and blue ROTB logo in a vertical composition.",
        "newCollection": true,
        "variants": [
            {
                "name": "Freestyler",
                "price": "€45"
            },
            {
                "name": "Asher",
                "price": "€48"
            }
        ]
    },
    {
        "id": "freestyler-original",
        "name": "Original",
        "price": "€45",
        "image": "/collection/original.png",
        "type": "T-Shirt",
        "description": "The original vertical ROTB graphic in purple and blue.",
        "newCollection": true,
        "variants": [
            {
                "name": "Freestyler",
                "price": "€45"
            },
            {
                "name": "Asher",
                "price": "€48"
            }
        ]
    },
    {
        "id": "freestyler-phases",
        "name": "Phases",
        "price": "€45",
        "image": "/collection/phasesV2.png",
        "type": "T-Shirt",
        "description": "Eight phases of ROTB, from Genesis to Elysium, together on one tee.",
        "newCollection": true,
        "variants": [
            {
                "name": "Freestyler",
                "price": "€45"
            },
            {
                "name": "Asher",
                "price": "€48"
            }
        ]
    },
    {
        "id": "freestyler-erosion",
        "name": "Erosion",
        "price": "€45",
        "image": "/collection/rotb_erosion_tee.png",
        "type": "T-Shirt",
        "description": "A vertical ROTB graphic in turquoise with gold erosion details.",
        "newCollection": true,
        "variants": [
            {
                "name": "Freestyler",
                "price": "€45"
            },
            {
                "name": "Asher",
                "price": "€48"
            }
        ]
    },
    {
        "id": "freestyler-pink",
        "name": "Pink",
        "price": "€45",
        "image": "/collection/rotb_pinkt_tee.png",
        "type": "T-Shirt",
        "description": "The vertical ROTB graphic in vivid pink.",
        "newCollection": true,
        "variants": [
            {
                "name": "Freestyler",
                "price": "€45"
            },
            {
                "name": "Asher",
                "price": "€48"
            }
        ]
    },
    {
        "id": "cooper-erosion",
        "name": "Erosion",
        "price": "€69",
        "image": "/collection/cooper_erosion.png",
        "type": "Cooper Hoodie",
        "description": "A turquoise and gold ROTB graphic across the back of a black hoodie.",
        "newCollection": true
    },
    {
        "id": "cooper-girl",
        "name": "Girl Grey",
        "price": "€69",
        "image": "/collection/cooper_no_pill.png",
        "type": "Cooper Hoodie",
        "description": "A monochrome portrait with the bracketed ROTB signature on a black hoodie.",
        "newCollection": true
    },
    {
        "id": 1,
        "name": "Girl Tee",
        "price": "€45",
        "image": "/rotb_girl_tee.png",
        "type": "T-Shirt",
        "description": "The original ROTB portrait tee.",
        "variants": [
            {
                "name": "Freestyler",
                "price": "€45"
            },
            {
                "name": "Asher",
                "price": "€48"
            }
        ]
    },
    {
        "id": 2,
        "name": "Cyber Tee",
        "price": "€45",
        "image": "/tech_tee.png",
        "type": "T-Shirt",
        "description": "A monochrome ROTB graphic tee.",
        "variants": [
            {
                "name": "Freestyler",
                "price": "€45"
            },
            {
                "name": "Asher",
                "price": "€48"
            }
        ]
    }
];

export default products;

// Manufacturer specifications: Stanley/Stella STTU788 and STTU078.
export const teeSpecifications = {
    Freestyler: {
        gsm: 240,
        fit: 'Relaxed fit',
        fabric: '100% organic cotton',
        finish: 'Heavyweight single jersey with a dry, slightly textured feel. Open-end carded cotton, fabric washed.',
    },
    Asher: {
        gsm: 280,
        fit: 'Oversized boxy fit',
        fabric: '100% organic cotton',
        finish: 'Heavyweight single jersey with a soft, structured feel. Ring-spun combed cotton, fabric washed.',
    },
};
